import {
    RangeControl,
    __experimentalBorderControl as BorderControl,
    Flex,
    FlexItem,
} from "@wordpress/components";

const BorderRange = ({
    borderValue,
    onBorderChange,
    rangeValue,
    onRangeChange,
    label,
    min = 0,
    max = 20,
    step = 1,
    hasNoMarginBottom = true,
}) => {
    return (
        <Flex align="end" justify="space-between">
            <FlexItem style={{ width: "50%", paddingRight: "15px" }}>
                <BorderControl
                    value={borderValue}
                    onChange={onBorderChange}
                    label={label}
                />
            </FlexItem>
            <FlexItem style={{ width: "50%" }}>
                <RangeControl
                    value={rangeValue}
                    onChange={onRangeChange}
                    withInputField={false}
                    min={min}
                    max={max}
                    step={step}
                    __nextHasNoMarginBottom={hasNoMarginBottom}
                />
            </FlexItem>
        </Flex>
    );
};

export default BorderRange;
